<!-- Los dos botones: la traza (lectura) y el ensayo (que es lo que abre Reportar). -->
<div class="inline-flex items-center gap-2">

  <button *ngIf="mostrarTraza && puedeVerTraza" (click)="verTraza()" type="button"
    [ngClass]="compacto ? 'text-xs px-2 py-1' : 'text-sm px-3 py-1.5'"
    class="border rounded hover:bg-gray-50">
    <i class="fas fa-history mr-1"></i>Traza
  </button>

  <!-- El botón NO se bloquea por haber enviado antes: la causa dominante de
       fallo son timeouts, así que reenviar arregla el caso legítimo. La
       duplicación la evita el pre-check contra SM. -->
  <button *ngIf="puedeReportar && puedeEnviar" (click)="abrirEnsayo()" [disabled]="enviando" type="button"
    [ngClass]="compacto ? 'text-xs px-3 py-1' : 'text-sm px-3 py-1.5'"
    class="bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50">
    <i class="fas mr-1" [ngClass]="enviando ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
    {{ enviando ? 'Enviando…' : etiqueta }}
  </button>
</div>

<!-- ENSAYO antes del envío: qué se le va a mandar a Mercantil.
     Reportar NO envía: abre esto. El envío es irreversible y el payload es
     invisible salvo que se mire. -->
<div *ngIf="previewAbierto" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" (click)="cerrarEnsayo()">
  <div class="bg-white rounded-lg max-w-3xl w-full max-h-[85vh] overflow-auto" (click)="$event.stopPropagation()">

    <div class="px-4 py-3 border-b flex items-center justify-between">
      <div>
        <div class="font-semibold text-gray-800">
          <i class="fas fa-flask mr-2 text-blue-600"></i>Ensayo del reporte
        </div>
        <div class="text-xs text-gray-500">
          Cuota {{ orden }} · Recibo {{ recibo || '—' }}
          <span *ngIf="polizaNumero"> · Póliza {{ polizaNumero }}</span>
          <span *ngIf="credito"> · {{ credito }}</span>
        </div>
      </div>
      <button (click)="cerrarEnsayo()" [disabled]="enviando" type="button" class="text-gray-400 hover:text-gray-600 disabled:opacity-40">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="p-4 space-y-4">

      <div *ngIf="previewLoading" class="text-center text-gray-500 py-8">
        <i class="fas fa-spinner fa-spin mr-2"></i>Simulando el envío…
      </div>

      <ng-container *ngIf="!previewLoading && preview">

        <!-- Los bloqueos primero: es lo que decide si el botón se puede pulsar -->
        <div *ngIf="preview.bloqueos?.length" class="bg-red-50 border border-red-200 rounded p-3">
          <div class="text-sm font-semibold text-red-800 mb-1">
            <i class="fas fa-ban mr-1"></i>No se puede reportar
          </div>
          <ul class="text-sm text-red-700 list-disc ml-5">
            <li *ngFor="let b of preview.bloqueos">{{ b }}</li>
          </ul>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div class="border rounded p-3">
            <div class="text-xs text-gray-500 uppercase mb-1">Lo nuestro</div>
            <div class="text-sm">Cuota <b>{{ preview.cuota?.orden }}</b> · {{ preview.cuota?.monto }} USD</div>
            <div class="text-sm">Recibo <b>{{ preview.cuota?.recibo || '—' }}</b></div>
            <div class="text-sm">Convenio {{ preview.cuota?.convenio || '—' }}</div>
            <div class="text-xs text-gray-500 mt-1" *ngIf="preview.pago">
              Ref {{ preview.pago.referencia || '—' }} · tasa {{ preview.pago.tasa || '—' }} ·
              {{ preview.pago.type_transaction }} · {{ preview.pago.fecha | date:'dd/MM/yyyy' }}
            </div>
            <!-- El medio de pago sale de la CUENTA por la que entró el cobro, no de
                 `typeTransaction`: los tres canales escriben AUTO ahí. Y el monto se
                 declara en bolívares, que es la moneda del campo en el payload. -->
            <!-- El canal sale de la cuenta por la que entró el cobro: `typeTransaction`
                 vale AUTO en el botón, en el débito inmediato y en la domiciliación,
                 así que no distingue ninguno de los tres. -->
            <div class="text-sm mt-1" *ngIf="preview.pago">
              Cobrado por <b>{{ preview.pago.canal || 'canal sin identificar' }}</b>
            </div>
            <div class="text-sm" *ngIf="preview.pago">
              Medio de pago a SM:
              <b *ngIf="preview.pago.medio_pago_sm">{{ preview.pago.medio_pago_sm }}</b>
              <b *ngIf="!preview.pago.medio_pago_sm" class="text-red-700">sin determinar</b>
            </div>
            <div class="text-sm" *ngIf="preview.pago?.monto_bs != null">
              Se reporta <b>{{ preview.pago.monto_bs }} Bs</b>
              ({{ preview.pago.monto_recibo_usd }} USD × {{ preview.pago.tasa }})
            </div>
            <div class="text-xs text-amber-700 mt-1" *ngIf="preview.pagos_asociados > 1">
              {{ preview.pagos_asociados }} pagos cubren esta cuota: se usa la referencia del último,
              el que cierra el cobro.
            </div>
          </div>

          <div class="border rounded p-3">
            <div class="text-xs text-gray-500 uppercase mb-1">Lo que dice SM</div>
            <div class="text-sm">Estado del recibo: <b>{{ preview.sm?.quote_status || 'sin dato' }}</b></div>
            <div class="text-sm">Pendiente en SM: {{ preview.sm?.pending_amount ?? '—' }}</div>
            <!-- Ausente NO significa "SM dice que no está pagada": significa que
                 nunca se lo preguntamos. -->
            <div class="text-xs mt-1" [ngClass]="preview.sm?.checked_at ? 'text-gray-500' : 'text-amber-700'">
              <span *ngIf="preview.sm?.checked_at">Verificado el {{ preview.sm.checked_at | date:'dd/MM/yyyy HH:mm' }}</span>
              <span *ngIf="!preview.sm?.checked_at">Nunca se le preguntó a SM: este dato es del último corte del sync</span>
            </div>
          </div>
        </div>

        <!-- El payload exacto. Es el punto del ensayo: que se LEA. -->
        <div *ngIf="preview.payload">
          <div class="flex items-center justify-between mb-1">
            <div class="text-xs text-gray-500 uppercase">Lo que se le va a enviar a Mercantil</div>
            <button (click)="copiarPayload()" type="button" class="text-xs text-blue-600 hover:underline">
              <i class="fas fa-copy mr-1"></i>Copiar
            </button>
          </div>
          <pre class="text-[11px] bg-gray-50 border rounded p-3 overflow-auto max-h-72">{{ previewJson }}</pre>
          <p class="text-xs text-gray-500 mt-1">
            <code>quote</code> va <b>siempre en 1</b>: es lo que espera SM en este reporte. El ordinal
            de la cuota ({{ preview.cuota?.orden }}) viaja en <code>agreement</code>, que es su sitio.
            Comprueba también que <code>approvalNumber</code> sea la referencia del cobro, que
            <code>exchangeRate</code> no venga vacío, que <code>payment.amount</code> esté en
            <b>bolívares</b> (el recibo × la tasa, no el monto en USD) y que
            <code>payment.type</code> sea el medio de pago real: <code>PDBDV</code> si el cobro entró
            por el botón de pago BDV, <code>PDMER</code> si fue por el botón Mercantil o por débito
            inmediato, y <code>TDD</code> si fue por domiciliación.
          </p>
        </div>

        <div *ngIf="!preview.payload && preview.error_ensayo" class="text-sm text-red-700">
          El ensayo no pudo armar el payload: {{ preview.error_ensayo }}
        </div>

      </ng-container>
    </div>

    <div class="px-4 py-3 border-t flex items-center justify-between bg-gray-50">
      <span class="text-xs text-gray-500">
        Al enviar se consulta primero el estado real en SM; si ya está pagada, no se manda nada.
      </span>
      <div class="flex gap-2">
        <button (click)="cerrarEnsayo()" [disabled]="enviando" type="button"
          class="px-3 py-1.5 border rounded text-sm disabled:opacity-40">Cancelar</button>
        <button (click)="confirmarEnvio()" [disabled]="enviando || previewLoading || previewBloqueado" type="button"
          class="px-4 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:opacity-40">
          <i class="fas" [ngClass]="enviando ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
          {{ enviando ? 'Enviando…' : 'Reportar a SM' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Traza de la cuota: envíos Y consultas -->
<div *ngIf="auditAbierto" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" (click)="cerrarTraza()">
  <div class="bg-white rounded-lg max-w-3xl w-full max-h-[80vh] overflow-auto" (click)="$event.stopPropagation()">
    <div class="px-4 py-3 border-b flex items-center justify-between">
      <div>
        <div class="font-semibold text-gray-800">
          Cuota {{ orden }} · Recibo {{ recibo || '—' }}
        </div>
        <div class="text-xs text-gray-500">
          <span *ngIf="polizaNumero">Póliza {{ polizaNumero }}</span>
          <span *ngIf="credito"> · {{ credito }}</span>
        </div>
      </div>
      <button (click)="cerrarTraza()" type="button" class="text-gray-400 hover:text-gray-600"><i class="fas fa-times"></i></button>
    </div>
    <div class="p-4">
      <div *ngIf="auditRows === null" class="text-center text-gray-500 py-6">
        <i class="fas fa-spinner fa-spin mr-2"></i>Cargando traza…
      </div>
      <div *ngIf="auditRows?.length === 0" class="text-center text-gray-500 py-6">
        Sin traza todavía. Esta cuota no se ha reportado ni consultado desde aquí.
      </div>
      <!-- Lo que le sirve a un reclamo contra Mercantil no es el estado final,
           es la insistencia: preguntamos el día X, el día Y, y las dos veces
           dijo que no. -->
      <div *ngFor="let a of auditRows" class="border-l-2 pl-3 py-2 mb-2"
        [ngClass]="a.result === 'SUCCESS' || a.result === 'RECOGNIZED' ? 'border-green-400' : 'border-gray-300'">
        <div class="text-sm">
          <span class="font-medium">{{ a.action }}</span>
          <span class="ml-2 px-2 py-0.5 rounded text-xs"
            [ngClass]="a.result === 'SUCCESS' || a.result === 'RECOGNIZED' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'">
            {{ a.result }}
          </span>
          <span class="text-gray-500 ml-2">{{ a.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}</span>
        </div>
        <div class="text-xs text-gray-500 mt-1">
          {{ a.actor?.name || 'sin actor' }}
          <span *ngIf="a.errorMessage" class="text-red-600 ml-2">· {{ a.errorMessage }}</span>
        </div>
        <details *ngIf="a.requestSnapshot || a.responseSnapshot" class="mt-1">
          <summary class="text-xs text-blue-600 cursor-pointer">Ver JSON</summary>
          <pre class="text-[10px] bg-gray-50 p-2 rounded overflow-auto mt-1">{{ { enviado: a.requestSnapshot, respuesta: a.responseSnapshot } | json }}</pre>
        </details>
      </div>
    </div>
  </div>
</div>
